import React from "react";
import { DateTimeControl } from "../controls/DateTimeControl";
import { TimeScaleControl } from "../controls/TimeScaleControl";
import { PlayPauseControl } from "../controls/PlayPauseControl";
import { CameraControl } from "../controls/CameraControl";
import { BodySelector } from "../controls/BodySelector";
import { OrbitVisibilityControl } from "../controls/OrbitVisibilityControl";
import { SimulationModeControl } from "../controls/SimulationModeControl";

export function Sidebar() {
  return (
    <aside className="tls-astro-sidebar">
      <h3>Controles</h3>
      <DateTimeControl />
      <PlayPauseControl />
      <TimeScaleControl />
      <BodySelector />
      <CameraControl />
      <OrbitVisibilityControl />
      <SimulationModeControl />
    </aside>
  );
}
